import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

export const editDetailedSummaryModalSchema = yupResolver(
  yup.object({
    categoryKey: yup.string().required('Categoria é obrigatória'),
    totalValue: yup.string().required('Valor Total é obrigatório'),
    observations: yup.string().required('Observações é obrigatória')
  })
)
